function MoneySendIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.05 16.8655H11.17C9.84001 16.8655 8.75 15.7455 8.75 14.3655C8.75 13.9555 9.09 13.6155 9.5 13.6155C9.91 13.6155 10.25 13.9555 10.25 14.3655C10.25 14.9155 10.66 15.3655 11.17 15.3655H13.05C13.44 15.3655 13.75 15.0155 13.75 14.5855C13.75 14.0455 13.6 13.9655 13.26 13.8455L10.25 12.7955C9.61 12.5655 8.75 12.1055 8.75 10.6355C8.75 9.38547 9.74001 8.35547 10.95 8.35547H12.83C14.16 8.35547 15.25 9.47547 15.25 10.8555C15.25 11.2655 14.91 11.6055 14.5 11.6055C14.09 11.6055 13.75 11.2655 13.75 10.8555C13.75 10.3055 13.34 9.85547 12.83 9.85547H10.95C10.56 9.85547 10.25 10.2055 10.25 10.6355C10.25 11.1755 10.4 11.2555 10.74 11.3755L13.75 12.4255C14.39 12.6555 15.25 13.1155 15.25 14.5855C15.25 15.8455 14.26 16.8655 13.05 16.8655Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        d="M12 17.8672C11.59 17.8672 11.25 17.5272 11.25 17.1172V8.11719C11.25 7.70719 11.59 7.36719 12 7.36719C12.41 7.36719 12.75 7.70719 12.75 8.11719V17.1172C12.75 17.5272 12.41 17.8672 12 17.8672Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        d="M12 23.3672C6.07 23.3672 1.25 18.5472 1.25 12.6172C1.25 6.68719 6.07 1.86719 12 1.86719C12.41 1.86719 12.75 2.20719 12.75 2.61719C12.75 3.02719 12.41 3.36719 12 3.36719C6.9 3.36719 2.75 7.51719 2.75 12.6172C2.75 17.7172 6.9 21.8672 12 21.8672C17.1 21.8672 21.25 17.7172 21.25 12.6172C21.25 12.2072 21.59 11.8672 22 11.8672C22.41 11.8672 22.75 12.2072 22.75 12.6172C22.75 18.5472 17.93 23.3672 12 23.3672Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        d="M22 7.36719C21.59 7.36719 21.25 7.02719 21.25 6.61719V3.36719H18C17.59 3.36719 17.25 3.02719 17.25 2.61719C17.25 2.20719 17.59 1.86719 18 1.86719H22C22.41 1.86719 22.75 2.20719 22.75 2.61719V6.61719C22.75 7.02719 22.41 7.36719 22 7.36719Z"
        fill="#1C274C"
        className="fill"
      />
      <path
        d="M16.9999 8.36859C16.8099 8.36859 16.6199 8.29859 16.4699 8.14859C16.1799 7.85859 16.1799 7.37859 16.4699 7.08859L21.4699 2.08859C21.7599 1.79859 22.2399 1.79859 22.5299 2.08859C22.8199 2.37859 22.8199 2.85859 22.5299 3.14859L17.5299 8.14859C17.3799 8.29859 17.1899 8.36859 16.9999 8.36859Z"
        fill="#1C274C"
        className="fill"
      />
    </svg>
  );
}

export default MoneySendIcon;
